import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { color, space, typography } from 'styled-system'

const StyledInlineLink = styled(Link).withConfig({ shouldForwardProp })(
  {
    color: 'inherit',
    textDecoration: 'underline',
    fontWeight: 500,
    transition: 'text-decoration-color 180ms ease-out',
    textDecorationColor: 'rgba(0, 0, 0, 0.2)',
    textUnderlineOffset: '0.2em',
    lineHeight: '1.2',

    '&:hover': {
      textDecorationColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  typography,
  space,
  color
)

const StyledExternalInlineLink = styled('a').withConfig({ shouldForwardProp })(
  {
    color: 'inherit',
    textDecoration: 'underline',
    fontWeight: 500,
    transition: 'text-decoration-color 180ms ease-out',
    textDecorationColor: 'rgba(0, 0, 0, 0.2)',
    textUnderlineOffset: '0.2em',
    lineHeight: '1.2',

    '&:hover': {
      textDecorationColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  typography,
  space,
  color
)

export const InlineLink = ({ to, external, children, ...props }) => {
  if (external) {
    return (
      <StyledExternalInlineLink
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </StyledExternalInlineLink>
    )
  }

  return (
    <StyledInlineLink to={to} {...props}>
      {children}
    </StyledInlineLink>
  )
}
